<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Stock/ ຈັດຊື້ສິນຄ້າເຂົ້າສາງ
           
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6 || roleid == 7">
        <b-tab-item label="ລາຍການສິນຄ້າ">
          <div class="columns">
            <div class="column" style="color: white">   
              -  
            </div>
            <div class="column" style="color: white">   
              -  
            </div>
            <div class="column" style="color: white">   
              -  
            </div>
            <div class="column">
                <b-datepicker
                    :date-formatter="dateFormatter"
                    v-model="requestdate"
                >
                </b-datepicker>
            </div>
            <div class="column" style="text-align: right">
              <b-button
                  class="btn-group-margin"
                  type="is-success"
                  @click="sendStockRequestToMarket()"
                >ສົ່ງລາຍການຈັດຊື້
              </b-button>    
            </div>
          </div> 

          <div class="columns">
            <div class="column" style="color: white">   
              -  
            </div>
            <div class="column" style="color: white">   
              -  
            </div>
            <div class="column" style="color: white">   
              -  
            </div>
           <div class="column" style="color: white">   
              -  
            </div>
            <div class="column" style="text-align: right">
              <b-button
                  class="btn-group-margin"
                  type="is-info"
                  @click="saveStockProductRequest()"
                >ບັນທຶກລາຍການ
              </b-button>    
            </div>
          </div>                  
          
          <table class="table is-fullwidth is-narrow is-small">
            <thead>
              <tr>
                <th class="has-text-centered " width="2%">#</th>

                <th class="has-text-left " width="30%">
                  ຊື່ສິນຄ້າ
                </th>
                <th class="has-text-right " width="15%">
                  ຍັງເຫຼືອ
                </th>
                <th class="has-text-centered " width="8%">
                  ຕ້ອງການ
                </th>
                <th class="has-text-centered " width="18%">
                  ຜູ້ສະໜອງ
                </th>
                <th class="has-text-centered " width="10%">
                  ຜູ້ຊື້
                </th>
                <th class="has-text-centered " width="10%">
                  ຈັດການ
                </th>  
              </tr>   
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in stockProductList"
                :key="data.PRODUCTID"
              >
                <td class="has-text-centered " :style="data.QUANTITY > 0 && (data.VENDERNAME == null || data.PURCHASERNAME) == null ? { backgroundColor: 'red', color: 'white' } : {}">
                  {{ index + 1 }}
                </td>
                <td class="has-text-left " :style="data.QUANTITY > 0 && (data.VENDERNAME == null || data.PURCHASERNAME) == null ? { backgroundColor: 'red', color: 'white' } : {}">
                    {{data.PRODUCTID}}-{{ data.PRODUCTNAME }}
                </td>
                <td class="has-text-right " :style="data.QUANTITY > 0 && (data.VENDERNAME == null || data.PURCHASERNAME) == null ? { backgroundColor: 'red', color: 'white' } : {}">  
                  <span style="color: red;">{{ data.STOCKQUANTITY | formatNumberLocal }}</span> {{data.UNIT}}
                </td>
              
                
                <td class="has-text-right" >
                  <b-field>      
                        
                    <b-input width="100px"
                      v-model.trim="data.QUANTITY"
                      type="number"
                      step="any"
                    >     
                    </b-input>
                  </b-field>
                  
                  
                </td> 
                <td class="has-text-centered">  
                  <span v-if="data.VENDERNAME" style="color: red;">
                    {{ data.VENDERNAME }}<br>
                  </span>
                 
                  <Multiselect
                    placeholder="ຜູ້ສະໜອງ"
                    v-model="data.VENDER"
                    label="NAME"
                    track-by="ID"
                    :options="getVendorOptions(data.STOCKVENDERID)"
                    @input="onSelectVender(index)"
                  >
                  </Multiselect>
               
                  
                </td> 
                <td class="has-text-centered">  
                  <span v-if="data.PURCHASERNAME "  style="color: red;">
                    {{ data.PURCHASERNAME }}<br>
                  </span>
                  <Multiselect
                    placeholder="ຜູ້ຊື້"
                    v-model="data.PURCHASER"
                    label="NAME"
                    track-by="ID"
                    :options="purchaserList"
                    @input="onSelectPurchaser(index)"
                  >
                  </Multiselect>
                  
                  
                  
                  
                </td>  
                <td class="has-text-centered">  
                  <b-button
                      class="btn-group-margin is-fullwidth"
                      type="is-info"
                      size="is-small"
                      @click="saveStockProductRequest()"    
                    >ບັນທຶກ
                  </b-button> 
                </td>

              </tr>
            </tbody>
            
          </table>
          
        </b-tab-item>

        <b-tab-item label="ລາຍການຈັດຊື້">
          <b-tabs v-model="activeTab2" >
            <b-tab-item label="ລາຍການລໍຖ້າຢືນຢັນ">
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="2%">#</th>

                    <th class="has-text-centered " width="10%">
                      ວັນທີ
                    </th>
                    <th class="has-text-centered " width="10%">
                      BATCHID
                    </th>
                    <th class="has-text-centered " width="10%">
                      ສະຖານະ
                    </th>
                    <th class="has-text-centered " width="10%">
                      ຈຳນວນສິນຄ້າ
                    </th>
                    <th class="has-text-centered " width="10%">
                      ຈັດການ
                    </th>  
                  </tr>   
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in stockMarketPurchaseList"
                    :key="data.ID"
                  >
                    <td class="has-text-centered ">
                      {{ index + 1 }}
                    </td>
                    <td class="has-text-centered ">
                      {{data.REDATE }}
                    </td>

                    <td class="has-text-centered ">
                      {{data.MARKETBATCHID }}
                    </td>

                    <td class="has-text-centered">  
                      <span v-if="data.MARKETBATCHSTATUS==1"> 
                          ຢືນຢັນແລ້ວ<br> 
                      </span>
                      <div v-else-if="data.MARKETBATCHSTATUS == 0" style="color: red;">
                        ລໍຖ້າຢືນຢັນ<br> 
                          <!-- <b-button
                              class="btn-group-margin is-fullwidth mt-1"
                              type="is-success"
                              @click="confirmStockToMarket(data.ID)"    
                            >ຢືນຢັນ
                          </b-button>  -->
                      </div>
                    </td> 

                    <td class="has-text-centered">  
                      <span >{{ data.COUNTITEM | formatNumberLocal }}</span>
                    </td>  
                    <td class="has-text-centered">  
                      <div  v-if="data.MARKETBATCHSTATUS ==0">
                        
                        <div>
                          <b-button
                              class="btn-group-margin is-fullwidth"
                              type="is-info"
                              @click="stockMarketDetail(data.ID, data.REDATE, data.MARKETBATCHID, data.MARKETBATCHSTATUS)"    
                            >ລາຍລະອຽດ
                          </b-button> 
                        </div>
                       
                      </div>
                      <div v-else> 

                        <div>
                          <b-button
                              class="btn-group-margin is-fullwidth"
                              type="is-info"
                              @click="stockMarketDetail(data.ID, data.REDATE, data.MARKETBATCHID,  data.MARKETBATCHSTATUS)"    
                            >ລາຍລະອຽດ
                          </b-button> 
                        </div>

                      </div>
                      
                    </td>

                  </tr>
                </tbody>
                
              </table>
            </b-tab-item>
            <b-tab-item label="ລາຍລະອຽດ">
              <div class="columns">
                <div class="column">
                  <div>
                    ວັນທີ: {{ selectedRedate }}
                  </div>
                  <div>
                    Batchid: {{ selectedBatchid }}  
                  </div>
                </div>
                <div class="column" >   
                  <b-field v-if="isConfirmed==1 || marketbatchstatus ==1" style="float: right;">   
                    ຢືນຢັນແລ້ວ
                  </b-field>
                  <b-field v-else style="color: red; float: right;">
                    <b-button 
                        class="btn-group-margin is-fullwidth mt-1"
                        type="is-success"
                        @click="confirmStockToMarket(selectedpurchaseid)"    
                      >ຢືນຢັນ
                    </b-button>
                    
                  </b-field>
                    
                </div>
              </div>
     
                
         
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="2%">#</th>

                    <th class="has-text-left " width="40%">
                      ຊື່ສິນຄ້າ
                    </th>
                 
                    <th class="has-text-centered " width="10%">
                      ຕ້ອງການ
                    </th>
                    <th class="has-text-left " width="15%">
                      ຜູ້ສະໜອງ
                    </th>
                    <th class="has-text-left " width="10%">
                      ຜູ້ຊື້
                    </th>
                    <th class="has-text-centered " width="10%">
                      ແຈ້ງເຂົ້າສາງ
                    </th>
                  </tr>   
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in purchaserDetailList"
                    :key="data.ID"
                  >
                    <td class="has-text-centered ">
                      {{ index + 1 }}
                    </td>
                    <td class="has-text-left ">
                      {{data.PRODUCTNAME }}
                    </td>

                    <td class="has-text-centered ">
                      {{data.QUANTITY }} {{ data.UNIT }}
                    </td>

                    <td class="has-text-left">  
                      {{data.VENDERNAME }}
                    </td> 

                    <td class="has-text-left">  
                      <span >{{ data.PURCHASERNAME }}</span>
                    </td> 
                    
                    <td class="has-text-centered">
                      <b-field v-if="data.ISMORNINGCHECK == 0 && data.HISTORYID==0 && data.MARKETSTATUS ==0 && data.MARKETBATCHSTATUS ==0 && isConfirmed==0">
                        <b-button
                            class="btn-group-margin is-fullwidth"
                            type="is-info"
                            @click="productToMorningCheck(data.ID)"    
                          >ແຈ້ງເຂົ້າສາງຕອນເຊົ້າ
                        </b-button>
                      </b-field>  
                      <b-field v-else-if="data.ISMORNINGCHECK == 1" style="color: red;">  
                        ສົ່ງຂໍ້ມູນແລ້ວ
                      </b-field>
                     
                    </td> 
                    

                  </tr>
                </tbody>
                
              </table>
            </b-tab-item>
          </b-tabs>
                
         
          
        </b-tab-item>
      </b-tabs>
    </div>
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect},

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 0,
      activeTab2: 0,
      
      stockProductList: [],
      requestdate: null,

      stockVenderList: [],
      selectedVender: null,

      purchaserList: [],
      selectedPurchaser: null,

      stockMarketPurchaseList: [],

      selectedRedate: null,
      selectedBatchid: null,

      purchaserDetailList: [],

      selectedpurchaseid: null,

      isConfirmed: 0,
      marketbatchstatus: 0,


    };
    
    
  },
  methods: {   

    productToMorningCheck(ID){
      this.$swal({
          title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {

            var params = {
              purchasedetailid: ID,    
              username: this.username,    
            };

            const loadingComponent = this.$loading.open({});
            RestAPI.productToMorningCheck(params)
              .then((res) => {
                if(res.data=="ok"){
                  this.$swal({
                    title: "ສຳເລັດ",
                    text: "ດຳເນີນການ ສຳເລັດ!",
                    icon: "success",
                    timer: 500,
                    showConfirmButton: false, 
                  });
                }
                
                loadingComponent.close();
                this.stockMarketDetail(this.selectedpurchaseid, this.selectedRedate,  this.selectedBatchid, this.marketbatchstatus);
               
              })  
              .catch((error) => {
                loadingComponent.close();
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                } 
              });

            

          }
        });   
    },

    stockMarketDetail(id, redate, batchid, marketbatchstatus){
      this.marketbatchstatus = marketbatchstatus;
      this.selectedpurchaseid = id;
      this.selectedRedate = redate;
      this.selectedBatchid = batchid;
      this.activeTab2 = 1;

      RestAPI.getStockMarketDetail(id)
      .then((res) => {
        this.purchaserDetailList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });

    },

    confirmStockToMarket(ID){
      this.$swal({
          title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {

            var params = {
              purchaseid: ID,    
              username: this.username,    
            };

            const loadingComponent = this.$loading.open({});
            RestAPI.confirmStockToMarket(params)
              .then((res) => {
                if(res.data=="ok"){
                  
                  this.isConfirmed = 1;
                  this.$swal({
                    title: "ສຳເລັດ",
                    text: "ດຳເນີນການ ສຳເລັດ!",
                    icon: "success",
                    timer: 500,
                    showConfirmButton: false, 
                  });
                }
                
                loadingComponent.close();
                this.getStockProductList();
                this.getStockMarketPurchaseList();
                this.activeTab = 1;
               
              })  
              .catch((error) => {
                loadingComponent.close();
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                } 
              });

            

          }
        });

    },

    getStockMarketPurchaseList(){
      RestAPI.getStockMarketPurchaseList()
      .then((res) => {
        this.stockMarketPurchaseList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    onSelectVender(index){
      this.stockProductList[index].VENDERNAME =  this.stockProductList[index].VENDER.NAME;
    },
    onSelectPurchaser(index){
      this.stockProductList[index].PURCHASERNAME =  this.stockProductList[index].PURCHASER.NAME;
    },

    reSelectVenderForm(index) {
      this.stockProductList[index].VENDERNAME = null;
      this.stockProductList[index].VENDER = {}; 
    },

    reSelectPurchaserForm(index){
      this.stockProductList[index].PURCHASER = {}; 
      this.stockProductList[index].PURCHASERNAME = null; 
    },


    sendStockRequestToMarket(){
      this.isConfirmed = 0;
      this.activeTab2 = 0;
      this.$swal({
          title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {

            var params = {
              data: this.stockProductList,  
              redate: this.dateFormatterYYYYMMDD(this.requestdate),
              username: this.username,    
            };
            // console.log("pararms: " + JSON.stringify(params))  

            const loadingComponent = this.$loading.open({});
            RestAPI.sendStockRequestToMarket(params)
              .then((res) => {
                if(res.data=="ok"){
                  this.$swal({
                    title: "ສຳເລັດ",
                    text: "ດຳເນີນການ ສຳເລັດ!",
                    icon: "success",
                    timer: 500,
                    showConfirmButton: false, 
                  });
                }
                
                loadingComponent.close();
                this.getStockProductList();
                this.getStockMarketPurchaseList();
                this.activeTab = 1;
               
              })  
              .catch((error) => {
                loadingComponent.close();
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                } 
              });

            

          }
        });
    },

    saveStockProductRequest(){
      this.isConfirmed = 0;
      this.$swal({
          title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {

            var params = {
              data: this.stockProductList,  
              username: this.username,    
            };
            // console.log("pararms: " + JSON.stringify(params))  
            const loadingComponent = this.$loading.open({});
            RestAPI.saveStockProductRequest(params)
              .then((res) => {
                if(res.data=="ok"){
                  this.$swal({
                    title: "ສຳເລັດ",
                    text: "ດຳເນີນການ ສຳເລັດ!",
                    icon: "success",
                    timer: 500,
                    showConfirmButton: false, 
                  });
                }
                
                loadingComponent.close();
                this.getStockProductList();
                this.activeTab2 = 0; 
               
              })  
              .catch((error) => {
                loadingComponent.close();
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                } 
              });

            

          }
        });

    },
    

    getStockProductList() {
      RestAPI.getStockProductListForRequest()
      .then((res) => {
        // console.log("res: "+ JSON.stringify(res.data) )
        this.stockProductList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    getStockVenderList() {
      RestAPI.getStockVenderListForRequest()
      .then((res) => {
        this.stockVenderList = res.data.stockVenderList;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    getPurchaserList() {
      RestAPI.getPurchaserList()
      .then((res) => {
        this.purchaserList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    getVendorOptions(venderIdsString) {
      if (!venderIdsString) return [];
      const ids = venderIdsString.split(',').map(id => parseInt(id.trim()));
      return this.stockVenderList.filter(v => ids.includes(v.ID));
    },
   

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;

    this.currentDate = new Date();

    this.requestdate = new Date();

    this.getStockProductList();
    this.getStockVenderList();
    this.getPurchaserList();
    this.getStockMarketPurchaseList();

  },

  computed: {


   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-35 {
  flex: 0 0 20%;
}
.column-65 {
  flex: 0 0 80%;
}


.column-40 {
  flex: 0 0 35%;
}
.column-60 {
  flex: 0 0 65%;
}

.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}


@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
